module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"add":"Add","undo":"Undo","save":"Save","delete":"Delete selected GW","addGwToStructure":"Add a gateway to the structure"},"it":{"add":"Aggiungi","undo":"Annulla","save":"Salva","delete":"Elimina GW selezionato","addGwToStructure":"Aggiungi un gateway alla struttura"}}')
  delete Component.options._Ctor
}
